import Swal from "sweetalert2";
import {responses} from "@/services/responses";
import copy from 'copy-to-clipboard';
import Vue from "vue";

// window.ChickenLittle = `http://192.168.1.142:8090/ChickenLittle/`
// window.ChickenLittle = `http://Musonda:8080/ChickenLittle/`
// window.franchiseTomcatApi = `https://192.168.1.142:8090/Franchise_OnlineServer/`
// window.KazangPaymentGateway = `http://192.168.1.142:8090/KazangPaymentGateway/V2/GateWay/`
// window.PaymentGateway = `http://192.168.1.142:8090/KazangPaymentGateway/`

// window.KazangPaymentGateway = `http://192.168.1.124:8080/KazangPaymentGateway/V2/GateWay/`
// window.PaymentGateway = `http://192.168.1.124:8080/KazangPaymentGateway/`

window.ChickenLittle = `https://lna.pos.co.zm/ChickenLittle/`

window.PaymentGateway = `https://lna.pos.co.zm/KazangPaymentGateway/`
window.franchiseTomcatApi = `https://overflow.pos.co.zm:8443/Franchise_OnlineServer/`
window.KazangPaymentGateway = `https://lna.pos.co.zm/kazangApi/`

window.copy = copy;
window.responses = responses;
window.Swal = Swal;

import {utils} from "./utils";
window.$utils = utils;

import {dateTimeManager} from "./TimeManager";
window.$dateTimeManager = dateTimeManager;
Vue.prototype.$dateTimeManager = dateTimeManager;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

// Usage tracking — fire-and-forget POST to Synergy Usage API.
// Used by router.afterEach for page views, and inline by click/submit handlers.
// See docs/references/usage-tracking.md for the full payload contract.
window.usageTracker = {
    getDeviceId() {
        let deviceId = localStorage.getItem('chrilan_device_id');
        if (!deviceId) {
            deviceId = 'dev_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
            localStorage.setItem('chrilan_device_id', deviceId);
        }
        return deviceId;
    },
    track(appKey, options = {}) {
        const payload = {
            app_key: appKey,
            user_id: options.userId || window.userId || null,
            device_id: this.getDeviceId(),
            feature: options.feature || null,
            action: options.action || 'view',
        };
        fetch('https://lna.pos.co.zm/SynergyApi/api/v1/usage/record', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).catch(err => console.warn('Usage tracking failed:', err));
    }
};
